import {
  InputAttributes,
  NumericFormat,
  NumericFormatProps,
} from 'react-number-format';
import { Input } from 'reactstrap';

interface NumericDecimalProps
  extends Omit<
    NumericFormatProps<InputAttributes>,
    | 'customInput'
    | 'decimalSeparator'
    | 'decimalScale'
    | 'fixedDecimalScale'
    | 'prefix'
  > {}

export const NumericDecimal = ({ ...rest }: NumericDecimalProps) => {
  return (
    <NumericFormat
      customInput={Input}
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale
      prefix=""
      {...rest}
    />
  );
};
